import React, { Component } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, Button, InputGroup, Table, Form, Dropdown, Alert, Badge } from 'react-bootstrap';
import { FaUserCog } from "react-icons/fa";
import axiosRequest from 'axios';
import { PiTrash, PiCloudArrowDownLight, PiFileCsvDuotone, PiPlus, PiX } from "react-icons/pi";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../../component/loader/loader';
import { getCookie, debounce } from "../../../function";
import CSVModal from "../../../component/rightside-modal/upload-csv-modal";
import RightSideModal from '../../../component/rightside-modal/rightside-modal';
import RemoveUsersCSVModal from "../../../component/rightside-modal/upload-remove-users-csv-modal";

var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;

export default class UserList extends Component {
    constructor(props) {
        super(props);
        this.isTAconnected = getCookie('isTAconnected');
        this.isTASyncing = getCookie('isTASyncing');
        this.state = {
            count: 0,
            limit: 10,
            search: '',
            show: false,
            loading: true,
            activePage: 1,
            groupTargets: [],
            fetchedTargets: [],
            checkedAll: false,
            statusCheck: false,
            checkedStatus: new Array(10).fill(false),
            targetId: 0,
            firstname: '',
            lastname: '',
            email: '',
            groupName: '',
            department: '',
            phone: '',
            position: '',
            designation: '',
            location: '',
            updateEmail: false,
            getAllCheckList: {},
            getSelectAll: {},
            departments: [],
            designations: [],
            locations: [],
            departmentId: "",
            designationId: "",
            locationId: "",
            showCSV: false,
            remainingUsersLimit: null,
            licenseExpiredAt: "",
            targetGroups: [],
            removeUsers_showCSV: false,
            permissibleActionsIAM: {},
            customFieldHeader: {},
            showLimitInLabel: false,
            filterPanelOpen: false,
            filterTab: 'department',
            filterDraftDepartmentId: '',
            filterDraftDesignationId: '',
            filterDraftLocationId: ''
        }
    }

    setFilterTab = (tab) => {
        this.setState({ filterTab: tab });
    }

    applyFilters = () => {
        this.setState({
            departmentId: this.state.filterDraftDepartmentId || '',
            designationId: this.state.filterDraftDesignationId || '',
            locationId: this.state.filterDraftLocationId || '',
            filterPanelOpen: false,
            activePage: 1
        }, () => this.load());
    }
    handleTargetsCSV = () => {
        const timeoutThreshold = 300;
        const timeout = setTimeout(() => {
            toast.info("Users list CSV is being prepared. Please wait...")
        }, timeoutThreshold);

        axios.get('/api/targets/all/csv', {})
            .then(async (res) => {
                clearTimeout(timeout);

                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `UsersList.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(error => {
                clearTimeout(timeout);
                apiError(error);
            });
    };


    componentDidMount = () => {
        this.load();
        this.loadPermissibleActions();
    }

    checkedGroup = (index) => {
        const checkedStatus = [...this.state.checkedStatus];
        checkedStatus[index] = !checkedStatus[index];
        this.setState({ checkedStatus: checkedStatus })
    }

    deleteTarget = (groupId, targetId) => {
        swal({
            title: "Are you sure you want to delete this user? The deletion will apply to all groups on TSAT and synced groups within TLMS",
            icon: "warning",
            buttons: ['No', 'Yes'],
            dangerMode: true,
        })
            .then(willSuccess => {
                if (willSuccess) {
                    axios.delete('/api/targets/' + targetId, {})
                        .then(async (res) => {
                            toast.success("User Deleted Successfully");
                            this.setState({ search: "" })
                            this.load();
                        })
                        .catch(error => apiError(error))
                }
            });

    }

    fetchAllLocalTargets = async () => {
        this.setState({ loading: true });
        if (cancelRequest) cancelRequest();

        axios.get('/api/targets/fetchAll/0', {
            params: {
                page: this.state.activePage,
                limit: this.state.limit,
                search: this.state.search,
                ...(this.state.departmentId && { departmentId: this.state.departmentId }),
                ...(this.state.designationId && { designationId: this.state.designationId }),
                ...(this.state.locationId && { locationId: this.state.locationId })
            },
            cancelToken: new CancelToken(function executor(c) { cancelRequest = c; })
        })
            .then(async (res) => {
                this.setState({
                    loading: false,
                    count: res.data.response.totalTargetsCount,
                    groupTargets: res.data.response.targets,
                    customFieldHeader: res.data.response.customFieldHeader || {}
                });
            })
            .catch(error => {
                if (!axiosRequest.isCancel(error)) {
                    this.setState({ groupTargets: [], count: 0, loading: false });
                    apiError(error);
                }
            });
    }


    load = debounce(() => {
        this.fetchLicenseDetails();
        this.fetchAllLocalTargets();

    }, 500)
    loadDepartments = async (skipLoading = false) => {
        if (!skipLoading) this.setState({ loading: true });
        axios.get('/api/departments', {})
            .then(async (res) => {
                this.setState({
                    ...(skipLoading ? {} : { loading: false }),
                    departments: res.data?.departments ?? [],
                })
            })
            .catch(error => {
                this.setState({ departments: [], ...(skipLoading ? {} : { loading: false }) });
                apiError(error);
            })
    }
    loadDesignations = async (skipLoading = false) => {
        if (!skipLoading) this.setState({ loading: true });
        axios.get('/api/designations', {})
            .then(async (res) => {
                this.setState({
                    ...(skipLoading ? {} : { loading: false }),
                    designations: res.data?.designations ?? [],
                })
            })
            .catch(error => {
                this.setState({ designations: [], ...(skipLoading ? {} : { loading: false }) });
                apiError(error);
            })
    }
    loadLocations = async (skipLoading = false) => {
        if (!skipLoading) this.setState({ loading: true });
        axios.get('/api/locations', {})
            .then(async (res) => {
                this.setState({
                    ...(skipLoading ? {} : { loading: false }),
                    locations: res.data?.locations ?? [],
                })
            })
            .catch(error => {
                this.setState({ locations: [], ...(skipLoading ? {} : { loading: false }) });
                apiError(error);
            })
    }
    handleSelectAllCheck = (e) => {
        let checkedElement = {};
        if (e.target.checked) {
            for (let elem of this.state.groupTargets) {
                // elem = elem.target;
                checkedElement[elem.id] = elem.id;
            }
            this.setState(prevState => ({
                getAllCheckList: { ...prevState.getAllCheckList, ...checkedElement },
                getSelectAll: { ...prevState.getSelectAll, [prevState.activePage]: true }
            }));
        }
        else {
            const selectedUsers = JSON.parse(JSON.stringify(this.state.getAllCheckList));
            for (let elem of this.state.groupTargets) {
                // elem = elem.target;
                if (selectedUsers[elem.id]) delete selectedUsers[elem.id];
            }
            this.setState(prevState => ({
                getAllCheckList: selectedUsers,
                getSelectAll: { ...prevState.getSelectAll, [prevState.activePage]: false }
            }));
        }
    }
    handleSingleCheck = (e, id) => {
        const singleSelectedElm = JSON.parse(JSON.stringify(this.state.getAllCheckList));
        if (!e.target.checked) {
            delete singleSelectedElm[id]
            this.setState({ getAllCheckList: singleSelectedElm });
        }
        else {
            this.setState({ getAllCheckList: { ...this.state.getAllCheckList, [id]: id } });
        }
        let isAllSelected = true;
        for (let i = 0; i < this.state.groupTargets?.length; i++) {
            const elem = this.state.groupTargets[i]
            const isCurrentElem = id === elem.id;
            const isCurrentSelected = isCurrentElem && e.target.checked;
            if ((isCurrentElem && !e.target.checked) || (!isCurrentSelected && !singleSelectedElm[elem.id])) isAllSelected = false;
        }
        this.setState({ getSelectAll: { ...this.state.getSelectAll, [this.state.activePage]: isAllSelected } })
    }
    deleteMultipleTargets = () => {
        try {
            swal({
                title: "Are you sure you want to delete these users? The deletion will apply to all groups on TSAT and synced groups within TLMS",
                icon: "warning",
                buttons: ['No', 'Yes'],
                dangerMode: true,
            })
                .then(willSuccess => {
                    if (willSuccess) {
                        axios.post('/api/targets', { targetIds: Object.keys(this.state.getAllCheckList) })
                            .then(async (res) => {
                                toast.success("Users Deleted Successfully");
                                this.setState({ search: "", getSelectAll: {}, getAllCheckList: {} })
                                this.load();
                            })
                            .catch(error => apiError(error))
                    }
                });
        } catch (error) {
            toast.error("Error deleting the users");
        }
    }
    CSVHandle = () => {
        this.setState({ showCSV: !this.state.showCSV });
    }
    removeUsers_CSVHandle = () => {
        this.setState({ removeUsers_showCSV: !this.state.removeUsers_showCSV });
    }
    fetchLicenseDetails = async () => {
        try {
            let licenseDetails = await axios.get('/api/overview/licence');
            this.setState({ remainingUsersLimit: licenseDetails.data.userlimit - licenseDetails.data.targetCount, licenseExpiredAt: new Date(licenseDetails.data.expiredAt) });
        } catch (error) {
            apiError(error);
        }
    }
    fetchTargetGroups = async (targetId) => {
        try {
            let response = await axios.get(`/api/targets/${targetId}/groups`);
            this.setState({ targetGroups: response.data.groups })
        } catch (error) {
            apiError(error);
        }
    }
    loadPermissibleActions = async () => {
        try {
            let permissibleActions = await axios.post('/api/iam-user/permissions', {
                actions: ['user-and-department-read', 'user-and-department-write', 'user-and-department-delete']
            });
            this.setState({ permissibleActionsIAM: permissibleActions.data.permissibleObj });
        } catch (error) {
            console.log("Error occured while fetching permissibleActionsIAM: ", error);
        }
    }

    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Users</h4>
                            </div>
                        </div>

                        <div className="col-md-8 flexFilterButtons">
                            <div className="btn-container d-flex align-items-center" style={this.isTAconnected ? { flexDirection: 'row-reverse' } : {}}>
                                {this.isTAconnected? 
                                    <Button variant="secondary" className=" btn-with-icon mr-2" onClick={this.handleTargetsCSV}> <PiFileCsvDuotone /> Export CSV</Button>
                                    :    
                                    <Dropdown className="dropdownIcon">
                                        <Dropdown.Toggle id="dropdown-basic" variant="secondary" className="dropdown-toggle mr-2">
                                            <PiCloudArrowDownLight className="ti-cloud-down tiIcon" />Bulk Operations
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {!this.isTAconnected && !this.isTASyncing && this.state.permissibleActionsIAM['user-and-department-write'] &&
                                                <>
                                                    <Dropdown.Item
                                                        className={`${this.isTASyncing ? "disabledCls3" : ""}`}
                                                        onClick={!this.isTASyncing && this.state.permissibleActionsIAM['user-and-department-write'] && this.CSVHandle}
                                                    >
                                                        Import Users
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className={`${this.isTASyncing ? "disabledCls3" : ""}`}
                                                        onClick={!this.isTASyncing && this.state.permissibleActionsIAM['user-and-department-write'] && this.removeUsers_CSVHandle}
                                                    >
                                                        Delete Users
                                                    </Dropdown.Item>
                                                </>
                                            }
                                            <Dropdown.Item onClick={this.handleTargetsCSV}>Export Users</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                }
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        this.isTASyncing ? (
                                            <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                            </Tooltip>
                                        ) : (
                                            (!this.state.permissibleActionsIAM['user-and-department-write'] ?
                                                <Tooltip id="top"> <span>You don't have permission to access</span></Tooltip>
                                                : <Tooltip id="top" className="d-none" />)
                                        )
                                    }
                                >
                                    <Button
                                        className={` btn-with-icon btn-primary ${(this.isTASyncing || !this.state.permissibleActionsIAM['user-and-department-write']) ? "disabledCls2" : ""}`}
                                        onClick={() => {
                                            if (this.isTAconnected) {
                                                window.location.href = `${process.env.REACT_APP_THREATCOP_ADMIN}/directory/users`;
                                                return;
                                            }
                                            if (!this.isTASyncing && this.state.permissibleActionsIAM['user-and-department-write']) {
                                                this.setState({ show: true });
                                            }
                                        }}
                                        style={this.isTAconnected ? { marginRight: '5px', textDecoration: 'underline' } : {}}
                                    >
                                        {this.isTAconnected ? <><FaUserCog /> User Management</> : <><PiPlus /> Add User </>}
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>



                {Object.keys(this.state.getAllCheckList).length > 0 && <div className="deleteUser">
                    <div className="selectedCount"> <p>{Object.keys(this.state.getAllCheckList).length} selected</p></div>
                    <Button variant="danger" className="btn-sm btn-trans-danger" onClick={this.deleteMultipleTargets}> <PiTrash style={{ marginTop: "-3px" }} /> Delete</Button>
                </div>}
                <div className="contentbar tableContainerWrap appTable">

                    <div className="filter-without-border">
                        <div className="align-items-center row">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={e => this.setState({ search: e.target.value, activePage: 1 }, () => { this.load() })} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>

                            <div className="col-md-9">
                                <div className="rightFilters">

                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
                                            Show{this.state.showLimitInLabel ? ` (${this.state.limit})` : ''}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 25, 50, 100].map((limit) => (
                                                <Dropdown.Item
                                                    key={`limit-${limit}`}
                                                    onClick={() => this.setState({ limit: limit, activePage: 1, showLimitInLabel: true }, () => this.load())}
                                                    active={this.state.limit === limit}
                                                >
                                                    {limit}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <Dropdown
                                        show={this.state.filterPanelOpen}
                                        onToggle={(isOpen) => {
                                            if (isOpen) {
                                                this.loadDepartments(true);
                                                this.loadDesignations(true);
                                                this.loadLocations(true);
                                            }
                                            this.setState({
                                                filterPanelOpen: isOpen,
                                                ...(isOpen ? {
                                                    filterDraftDepartmentId: this.state.departmentId || '',
                                                    filterDraftDesignationId: this.state.designationId || '',
                                                    filterDraftLocationId: this.state.locationId || '',
                                                    filterTab: 'department'
                                                } : {})
                                            });
                                        }}

                                    >
                                        <Dropdown.Toggle variant="secondary" id="filter-dropdown" className="dropdown-color-white">
                                            Filter
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="filter-panel-dropdown p-0" style={{ minWidth: '360px' }}>
                                            <div className="d-flex">
                                                <div className="filter-vertical-tabs border-right" style={{ width: '120px', minHeight: '220px' }}>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item text-left ${this.state.filterTab === 'department' ? 'active' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('department')}
                                                    >
                                                        Department
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item ${this.state.filterTab === 'designation' ? 'active' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('designation')}
                                                    >
                                                        Designation
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item ${this.state.filterTab === 'location' ? 'active' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('location')}
                                                    >
                                                        Location
                                                    </button>
                                                </div>
                                                <div className="filter-tab-content flex-grow-1" style={{ minHeight: '220px' }}>
                                                    {this.state.filterTab === 'department' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Select Department</h6>
                                                            <div className="filter-content-wrapper">
                                                                <FormControl
                                                                    as="select"
                                                                    value={String(this.state.filterDraftDepartmentId ?? '')}
                                                                    className="form-control"
                                                                    onChange={(e) => this.setState({ filterDraftDepartmentId: e.target.value || '' })}
                                                                >
                                                                    <option value="">All</option>
                                                                    {(this.state.departments || []).map((dep) => (
                                                                        <option key={'dep-' + dep.id} value={String(dep.id)}>{dep.name}</option>
                                                                    ))}
                                                                </FormControl>
                                                            </div>
                                                        </>
                                                    )}
                                                    {this.state.filterTab === 'designation' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Select Designation</h6>
                                                            <div className="filter-content-wrapper">
                                                                <FormControl
                                                                    as="select"
                                                                    value={String(this.state.filterDraftDesignationId ?? '')}
                                                                    className="form-control"
                                                                    onChange={(e) => this.setState({ filterDraftDesignationId: e.target.value || '' })}
                                                                >
                                                                    <option value="">All</option>
                                                                    {(this.state.designations || []).map((des) => (
                                                                        <option key={'des-' + des.id} value={String(des.id)}>{des.name}</option>
                                                                    ))}
                                                                </FormControl>
                                                            </div>
                                                        </>
                                                    )}
                                                    {this.state.filterTab === 'location' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Select Location</h6>
                                                            <div className="filter-content-wrapper">
                                                                <FormControl
                                                                    as="select"
                                                                    value={String(this.state.filterDraftLocationId ?? '')}
                                                                    className="form-control"
                                                                    onChange={(e) => this.setState({ filterDraftLocationId: e.target.value || '' })}
                                                                >
                                                                    <option value="">All</option>
                                                                    {(this.state.locations || []).map((loc) => (
                                                                        <option key={'loc-' + loc.id} value={String(loc.id)}>{loc.name}</option>
                                                                    ))}
                                                                </FormControl>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="filter-panel-footer p-2 border-top d-flex justify-content-end">
                                                <Button variant="primary" size="md" onClick={this.applyFilters}>Apply</Button>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                </div>
                            </div>
                        </div>
                    </div>



                    {(this.state.licenseExpiredAt && this.state.licenseExpiredAt <= new Date()) ? (
                        <div
                            style={{
                                lineHeight: '1.2',
                                borderRadius: 'none'
                            }}
                            className="licensAlert mb-3"
                        >
                            <Alert
                                variant="danger"
                                style={{
                                    padding: '6px 15px',
                                    margin: '0'
                                }}
                            >
                                <h6>Your license has been expired...</h6>
                            </Alert>
                        </div>

                    ) : (
                        (this.state.remainingUsersLimit && this.state.remainingUsersLimit > 0 ?
                            (
                                <div className="noteSection mt-0">
                                    <p><b>Please Note:</b> You can onboard {this.state.remainingUsersLimit} more unique users before reaching your limit. </p>
                                </div>

                            ) : (
                                (this.state.remainingUsersLimit !== null && this.state.remainingUsersLimit <= 0 ?
                                    <div

                                        className="licensAlert mb-3"
                                    >
                                        <Alert
                                            variant="danger"

                                        >
                                            <h6>Your user license limit has been reached. To add more users, please upgrade your license or remove existing users</h6>
                                        </Alert>
                                    </div> : ("")
                                )
                            )
                        )

                    )}


                    {(this.state.departmentId || this.state.designationId || this.state.locationId) && (
                        <div className="applied-filters-bar d-flex align-items-center flex-wrap mb-2">
                            {this.state.departmentId && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Department : {this.state.departments.find((d) => String(d.id) === String(this.state.departmentId))?.name || this.state.departmentId}
                                    <PiX
                                        className="ml-1 filter-badge-close"
                                        onClick={() =>
                                            this.setState(
                                                { departmentId: '', filterDraftDepartmentId: '', activePage: 1 },
                                                () => this.load()
                                            )
                                        }
                                    />
                                </Badge>
                            )}
                            {this.state.designationId && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Designation : {this.state.designations.find((d) => String(d.id) === String(this.state.designationId))?.name || this.state.designationId}
                                    <PiX
                                        className="ml-1 filter-badge-close"
                                        onClick={() =>
                                            this.setState(
                                                { designationId: '', filterDraftDesignationId: '', activePage: 1 },
                                                () => this.load()
                                            )
                                        }
                                    />
                                </Badge>
                            )}
                            {this.state.locationId && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Location : {this.state.locations.find((l) => String(l.id) === String(this.state.locationId))?.name || this.state.locationId}
                                    <PiX
                                        className="ml-1 filter-badge-close"
                                        onClick={() =>
                                            this.setState(
                                                { locationId: '', filterDraftLocationId: '', activePage: 1 },
                                                () => this.load()
                                            )
                                        }
                                    />
                                </Badge>
                            )}
                        </div>
                    )}




                  


{
  <>
    <div className="fixstickyinTable tableContainerWrapInner" style={{ overflowX: 'scroll' }}>
      <Table responsive style={{ overflowX: 'scroll' }}>
        <thead className="bg-light">
          <tr className="sticky-col">

            {!this.isTAconnected && this.state.permissibleActionsIAM['user-and-department-delete'] &&
              <th className="table-checkbox sticky-col">
                <input
                  style={{ cursor: 'pointer' }}
                  className="checkbox"
                  type="checkbox"
                  onChange={(e) => this.handleSelectAllCheck(e)}
                  checked={this.state.getSelectAll[this.state.activePage] ? true : false}
                />
              </th>
            }

            <th className="email sticky-col">Name / Email</th>
            <th>Designation</th>
            <th>Department</th>
            <th>Location</th>
            <th>Manager Email</th>
            <th>Phone</th>

            {this.state.customFieldHeader?.CF1 && <th>{this.state.customFieldHeader?.CF1}</th>}
            {this.state.customFieldHeader?.CF2 && <th>{this.state.customFieldHeader?.CF2}</th>}
            {this.state.customFieldHeader?.CF3 && <th>{this.state.customFieldHeader?.CF3}</th>}
            {this.state.customFieldHeader?.CF4 && <th>{this.state.customFieldHeader?.CF4}</th>}
            {this.state.customFieldHeader?.CF5 && <th>{this.state.customFieldHeader?.CF5}</th>}
            {this.state.customFieldHeader?.CF6 && <th>{this.state.customFieldHeader?.CF6}</th>}
            {this.state.customFieldHeader?.CF7 && <th>{this.state.customFieldHeader?.CF7}</th>}
            {this.state.customFieldHeader?.CF8 && <th>{this.state.customFieldHeader?.CF8}</th>}
            {this.state.customFieldHeader?.CF9 && <th>{this.state.customFieldHeader?.CF9}</th>}

            {!this.isTAconnected &&
              (this.state.permissibleActionsIAM['user-and-department-write'] ||
                this.state.permissibleActionsIAM['user-and-department-delete']) &&
              <th>Action</th>
            }
          </tr>
        </thead>

        <tbody>
          {this.state.groupTargets.length ? (
            this.state.groupTargets.map((target, index) => {
              const groupName = target.groupName;
              let targetId = target.id;
              let groupId = target.groupId;

              return (
                <tr key={index}>
                  {!this.isTAconnected && this.state.permissibleActionsIAM['user-and-department-delete'] &&
                    <td className="table-checkbox sticky-col">
                      <input
                        style={{ cursor: 'pointer' }}
                        className="checkbox"
                        type="checkbox"
                        onChange={(e) => this.handleSingleCheck(e, target.id)}
                        checked={this.state.getAllCheckList[target.id] ? true : false}
                      />
                    </td>
                  }

                  <td className="onlyForPinter email sticky-col">
                    <div className="flexTableData">
                      <div className="circle">
                        {(target?.firstname && target.firstname[0])}
                        {(target?.lastname && target.lastname[0])}
                      </div>
                      <div>
                        <h6>{target.firstname} {target.lastname || ''}</h6>
                        <span>{target.email}</span>
                      </div>
                    </div>
                  </td>

                  <td>{target.position || '---'}</td>
                  <td>{target.department || '---'}</td>
                  <td>{target.location != null ? target.location : '---'}</td>
                  <td>{target.managerEmail || '---'}</td>
                  <td>{target.phone || '---'}</td>

                  {this.state.customFieldHeader?.CF1 && <td>{target['CFV1'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF2 && <td>{target['CFV2'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF3 && <td>{target['CFV3'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF4 && <td>{target['CFV4'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF5 && <td>{target['CFV5'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF6 && <td>{target['CFV6'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF7 && <td>{target['CFV7'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF8 && <td>{target['CFV8'] || "---"}</td>}
                  {this.state.customFieldHeader?.CF9 && <td>{target['CFV9'] || "---"}</td>}

                  {!this.isTAconnected &&
                    (this.state.permissibleActionsIAM['user-and-department-write'] ||
                      this.state.permissibleActionsIAM['user-and-department-delete']) &&
                    <td>
                      {/* your dropdown code */}
                    </td>
                  }
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
                No User Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>

    {/* Pagination stays same */}
    <div className="pagination-Wrap" style={{ border: '1px solid #dfe2e6', borderTop: 'none' }}>
      <div className="row">
        <div className="col-md-6">
          {!this.state['loading'] ?
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.limit}
              totalItemsCount={this.state.count}
              onChange={(pageNumber) =>
                this.setState({ activePage: pageNumber }, () => this.load())
              }
            /> : <Loader />
          }
        </div>

        <div className="col-md-6 text-right d-flex align-items-center footer-pg">
          <div className="w-100 pgCount">
            <p>
              {this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit} -
              {this.state.activePage * this.state.limit > this.state.count
                ? this.state.count
                : this.state.activePage * this.state.limit} of {this.state.count} records
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
}
                </div>
                {!this.isTAconnected &&
                    <RightSideModal
                        load={this.load}
                        show={this.state.show}
                        phone={this.state.phone}
                        email={this.state.email}
                        groupName={this.state.groupName}
                        location={this.state.location}
                        department={this.state.department}
                        targetId={this.state.targetId}
                        lastname={this.state.lastname}
                        position={this.state.position}
                        firstname={this.state.firstname}
                        updateEmail={this.state.updateEmail}
                        handleModal={() => {
                            this.setState({
                                show: !this.state.show,
                                targetId: '0',
                                firstname: '',
                                lastname: '',
                                email: '',
                                groupName: '',
                                phone: '',
                                position: '',
                                location: '',
                                department: '',
                                search: '',
                            }, () => {
                                this.load();
                            })
                        }}
                    ></RightSideModal>
                }

                <CSVModal
                    show={this.state.showCSV}
                    CSVHandle={this.CSVHandle}
                    groupName={"Individual-Users"}
                    groupId={-1}></CSVModal>
                <RemoveUsersCSVModal removeUsers_showCSV={this.state.removeUsers_showCSV} removeUsers_CSVHandle={this.removeUsers_CSVHandle} fetchAllLocalTargets={this.fetchAllLocalTargets} />
                {this.state.loading ? <Loader></Loader> : null}
            </div>
        );
    }
}